import "jquery-mapael";
import "./germany";

(function ($) {

    $('.wp-block-map').each(function () {
        const id = '#' + $(this).attr('id');
        const vksMap = $(id).data('map');

        $(id + ' .map-container').mapael({
            map: {
                name : "germany",
                cssClass: "map",
                zoom: {
                    enabled: false
                },
                tooltip: {
                    cssClass: "map-tooltip absolute text-xs shadow-xl",
                },
                defaultArea : {
                    attrs: {
                        fill: 'none',
                        stroke: 'none',
                    },
                    attrsHover: {
                        fill: 'none',
                        stroke: 'none'
                    },
                    cssClass: 'area fill-current stroke-gray text-color3',
                    text: {
                        href: "#",
                        margin: {x : 7, y: 20},
                        attrs: {
                            fill: '#ffffff',
                        },
                        attrsHover: {
                            fill: '#ffffff',
                        },
                    },
                    tooltip: {
                        cssClass: "map-tooltip absolute text-white text-xs",
                    }
                },
                defaultPlot: {
                    attrs: {
                        fill: '#eef3f7'
                    },
                    eventHandlers: {
                        mouseover: function (e, id, mapElem, textElem, elemOptions) {
                            if (typeof elemOptions.domID != 'undefined') {
                                $('.legend-container [data-id="' + elemOptions.domID + '"]').removeClass('opacity-50').addClass('opacity-100 py-8');
                            }
                        },
                        mouseout: function (e, id, mapElem, textElem, elemOptions) {
                            if (typeof elemOptions.domID != 'undefined') {
                                $('.legend-container [data-id="' + elemOptions.domID + '"]').removeClass('opacity-100 py-8').addClass('opacity-50');
                            }
                        },
                    }
                }
            },
            plots: {
                ... vksMap.plots
            },
            legend: {
                plot: [
                  {
                        title: "",
                        cssClass: 'legend-types',
                        slices: [
                        ... vksMap.types
                        ]
                }
                ]
            },
            areas: {
                "BW": {
                    tooltip: {content: "Baden Württemberg"}
                },
                "BY": {
                    tooltip: {content: "Bayern"}
                },
                "BE" : {
                    tooltip: {content: "Berlin"}
                },
                "BB" : {
                    tooltip: {content: "Brandenburg"}
                },
                "HB" : {
                    tooltip: {content: "Bremen"}
                },
                "HH" : {
                    tooltip: {content: "Hamburg"}
                },
                "HE" : {
                    tooltip: {content: "Hessen"}
                },
                "MV" : {
                    tooltip: {content: "Mecklenburg-Vorpommern"}
                },
                "NI" : {
                    tooltip: {content: "Niedersachsen"}
                },
                "NW" : {
                    tooltip: {content: "Nordrhein-Westfalen"}
                },
                "RP" : {
                    tooltip: {content: "Rheinland-Pfalz"}
                },
                "SL" : {
                    tooltip: {content: "Saarland"}
                },
                "SN" : {
                    tooltip: {content: "Sachsen"}
                },
                "ST" : {
                    tooltip: {content: "Sachsen-Anhalt"}
                },
                "SH" : {
                    tooltip: {content: "Schleswig-Holstein"}
                },
                "TH" : {
                    tooltip: {content: "Thüringen"}
                },
            }
        });

    });

    $('[data-legend-type="plot"]').on('click', function () {
        let legendID = $(this).attr('data-id'),
            classes = 'opacity-20',
            legend = $('.legend-container[data-legend-id="' + legendID + '"]');

        legend.toggleClass(classes);
    });

})(jQuery);
